import Header from "./components/Header"
import Search from "./components/Search"

export default function App() {
  return (
    <div>
      <Header/>
      <Search/>
    </div>
  )
}
